import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onApplyClick: () => void;
}

const CTASection = ({ onApplyClick }: CTASectionProps) => {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-primary via-secondary to-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-64 h-64 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-5xl font-bold font-headline mb-6 leading-tight">
            Ready to Transform Your Consulting Practice?
          </h2>
          <p className="text-xl text-primary-foreground/90 mb-8 leading-relaxed font-body">
            Join an exclusive network of senior consultants delivering human-centered AI transformations to enterprise clients. Access proven methodologies, enterprise opportunities, and a collaborative professional community.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={onApplyClick}
              className="px-8 py-4 bg-accent text-accent-foreground rounded-lg font-semibold font-cta text-lg hover:bg-accent/90 transition-all duration-300 shadow-strong hover:shadow-xl hover:-translate-y-1 flex items-center gap-2"
            >
              Apply to Join Network
              <Icon name="ArrowRightIcon" size={20} variant="solid" />
            </button>
            
            <a
              href="/contact"
              className="px-8 py-4 bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground rounded-lg font-semibold font-cta text-lg hover:bg-primary-foreground/20 transition-all duration-300 flex items-center gap-2"
            >
              Schedule Discovery Call
              <Icon name="PhoneIcon" size={20} variant="outline" />
            </a>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-3">
              <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success" />
              <span className="text-sm font-body">No upfront fees</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success" />
              <span className="text-sm font-body">Flexible commitment</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success" />
              <span className="text-sm font-body">Ongoing support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;